export const FIND_ALL_SEASONS_COMPLETED = "project/seasons/findAllSeasonsCompleted";
export const FIND_SEASON_BY_ID_COMPLETED = "project/seasons/findSeasonByIdCompleted";
export const FIND_SEASONS_BETWEEN_TWO_DATES_COMPLETED = "project/seasons/findSeasonsBetweenTwoDatesCompleted";
export const UPDATE_SEASON_COMPLETED = "project/seasons/updateSeasonCompleted";
export const ADD_SEASON_COMPLETED = "project/seasons/addSeasonCompleted";
export const REMOVE_SEASON_COMPLETED = "project/seasons/removeSeasonCompleted";
export const FIND_SEASONS_TO_TEAM_COMPLETED = "project/seasons/findSeasonsToTeamCompleted";